import React, {useState, useEffect} from "react";
import {Button, Grid} from "@mui/material";
import ifwLogo from "../../assets/rr-color.png";
import UserMenu from "../user-menu";
import {useSelector} from "react-redux";
import {useCookies} from "react-cookie";
import NexusSalesModal from "../nexus-sales-modal";
import {SALES_COOKIE_AGE} from "../../config";

import MARKETING_ICON from "../../assets/education/marketing-icon.png";
import SIX_STEP_ICON from "../../assets/education/six-step-sales-icon.png";
import SOFTWARE_ICON from "../../assets/education/software-icon.png";
import GET_NEXUS_ICON from "../../assets/GetNexusBtn.png";

import "./layout.css";


const PresentationLayout2 = (props) => {

    const [showNexusSalesModal, setShowNexusSalesModal] = useState(false);
    const [cookies, setCookies] = useCookies();

    const fpid = useSelector((state) => state.dataStore.get("currentFPId"));

    const marketingLink = "https://www.ifwretirementroadmap.com/marketing-tools/"
    const sixStepsLink = "https://www.ifwretirementroadmap.com/ifw-retirement-roadmap-experience-six-step-sales-process-training-resource-library/"
    const softwareLink = "https://www.ifwretirementroadmap.com/ifw-retirement-roadmap-experience-software-training-resource-library/"

    const isPlanInputs = window.location.pathname.endsWith("/plan-inputs");
    const isPlanOutputs = window.location.pathname.endsWith("/plan-output");

    useEffect(() => {
        if (cookies.salesCookie) return;
        setShowNexusSalesModal(true);
        setCookies("salesCookie", true, { path: "/", maxAge: SALES_COOKIE_AGE });
    }, [cookies, setCookies, setShowNexusSalesModal]);

    const handleOpenNexusBtnClick = () => {
        setShowNexusSalesModal(true);
    }

    return (
        <div className={"presentation-page"}>
            <Grid container className={"presentation-header"}>
                <Grid item xs={6} >
                    <Grid container className={"header-container-images"}>
                        <img
                            style={{ height: '100%', objectFit: 'cover' }}
                            src={ifwLogo}
                            title={"Institute of Financial Wellness"}
                            alt={"Institute of Financial Wellness"}
                            className={"retirement-roadmap-logo"}
                        />
                    </Grid>
                </Grid>

                <Grid item xs={6} >

                    <div className={"container-user-controls"}>
                        {!isPlanInputs && (
                            <Button onClick={() => {
                                if (isPlanOutputs) {
                                    props.goToClientList();
                                } else {
                                    const id = (fpid !== undefined && fpid !== null) ? fpid : "";
                                    const target = `/ifw-users/2/${id}`;
                                    window.location.href = target;
                                }
                            }} height={"100%"}> Client list </Button>
                        )}
                        <UserMenu />
                    </div>

                    <div className="container-training-icons">
                        <a href="javascript:void(0)" onClick={handleOpenNexusBtnClick} style={{width: '24%'}}> <img src={GET_NEXUS_ICON}
                                                                                               style={{
                                                                                                   objectFit: 'contain',
                                                                                                   width: '100%'
                                                                                               }}/> </a>

                        <a href={marketingLink} target={"_blank"} style={{width: '24%'}}> <img src={MARKETING_ICON}
                                                                                               style={{
                                                                                                   objectFit: 'contain',
                                                                                                   width: '100%'
                                                                                               }}/> </a>
                        <a href={sixStepsLink} target={"_blank"} style={{width: '24%'}}> <img src={SIX_STEP_ICON}
                                                                                              style={{
                                                                                                  objectFit: 'contain',
                                                                                                  width: '100%'
                                                                                              }}/> </a>
                        <a href={softwareLink} target={"_blank"} style={{width: '24%'}}> <img src={SOFTWARE_ICON}
                                                                                              style={{
                                                                                                  objectFit: 'contain',
                                                                                                  width: '100%'
                                                                                              }}/> </a>
                    </div>

                    {props.children[0]}
                </Grid>
            </Grid>

            <Grid>
                {props.children[1]}
            </Grid>
            <NexusSalesModal
                open={showNexusSalesModal}
                handleClose={() => setShowNexusSalesModal(false)}
            />
        </div>
    );
};

export default PresentationLayout2;
